import { computed, ComputedRef } from 'vue'

import { EventDetailId } from '@collector/sportsapi-client-legacy'
import { useEventDetails } from '@desktop/views/Relation/composables'

export function useTimerDirection(
  timerDirectionEventDetailId: EventDetailId,
): ComputedRef<boolean> {
  const { getEventDetailValue } = useEventDetails()

  const isTimerDirectionDown = computed(() => {
    const eventDetailValue = getEventDetailValue(timerDirectionEventDetailId)

    switch (eventDetailValue) {
      case 'down':
        return true
      case 'up':
        return false
      default:
        throw Error(`Unexpected timer direction value: ${eventDetailValue}`)
    }
  })

  return isTimerDirectionDown
}
